import { Provider as StoreProvider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import ConsumersLegend from '@App/components/ConsumersLegend/ConsumersLegend.jsx';
import store from '@App/app.store';

import './consumer-legend-control.css';

class ConsumerLegendControl {
  onAdd() {
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl consumer-legend-control';
    this._root = createRoot(this._container);
    this._root.render(
      <StoreProvider store={store}>
        <ConsumersLegend />
      </StoreProvider>,
    );

    return this._container;
  }

  onRemove() {
    if (this._root) {
      queueMicrotask(() => {
        this._root.unmount();
      });
    }
    if (this._container?.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }
  }
}

export default ConsumerLegendControl;
